
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { 
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious
} from '@/components/ui/carousel';

const EventsSection = () => {
  const events = [
    {
      id: 1,
      title: "Préventica Lyon 2023",
      description: "Salon de l'investissement à Lyon où nous avons présenté nos solutions de gestion de patrimoine",
      image: "/lovable-uploads/608bc8de-de82-4d8a-801d-3fe96f232cd5.png",
      date: "8-10 Octobre 2023",
      presenter: "Le stand était tenu par Stephane Dassault, conseiller en gestion patrimoine et financière depuis 18 ans."
    },
    {
      id: 2,
      title: "Europropre 2023",
      description: "Salon de gestion de patrimoine à Paris où nous avons animé une conférence sur les cryptomonnaies",
      image: "/lovable-uploads/8cd0b916-168f-42ca-9cb4-1ed10792a099.png",
      date: "4-6 Avril 2023",
      presenter: "Une conférence tenue par Eric Menard, ancien chef de la salle des marchés de BNP Paribas à la Défense."
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-[#f8f9fa] to-white">
      <div className="container mx-auto px-4">
        <h2 className="section-title text-center mb-12">Nos Événements Récents</h2>
        
        <div className="text-center mb-10">
          <p className="text-lg text-patrimoine-muted max-w-3xl mx-auto">
            Découvrez les derniers événements auxquels nous avons participé pour partager notre expertise en gestion de patrimoine.
          </p>
        </div>

        <div className="hidden md:block">
          <div className="grid md:grid-cols-2 gap-12 max-w-6xl mx-auto">
            {events.map((event) => (
              <div key={event.id} className="flex flex-col">
                <div className="overflow-hidden border-4 border-gray-200">
                  <img 
                    src={event.image} 
                    alt={event.title} 
                    className="w-full h-auto object-contain"
                  />
                </div>
                <div className="bg-white p-6 flex-grow">
                  <div className="text-patrimoine-gold font-medium mb-2">{event.date}</div>
                  <h3 className="text-xl font-serif font-semibold mb-2">{event.title}</h3>
                  <p className="text-patrimoine-muted mb-4">{event.description}</p>
                  <p className="text-sm italic">{event.presenter}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Mobile Carousel */}
        <div className="md:hidden">
          <Carousel className="w-full max-w-sm mx-auto">
            <CarouselContent>
              {events.map((event) => (
                <CarouselItem key={event.id}>
                  <div className="flex flex-col">
                    <div className="overflow-hidden border-4 border-gray-200">
                      <img 
                        src={event.image} 
                        alt={event.title} 
                        className="w-full h-auto object-contain"
                      />
                    </div>
                    <div className="bg-white p-4 flex-grow">
                      <div className="text-patrimoine-gold font-medium mb-2">{event.date}</div>
                      <h3 className="text-lg font-serif font-semibold mb-2">{event.title}</h3>
                      <p className="text-patrimoine-muted mb-3">{event.description}</p>
                      <p className="text-sm italic">{event.presenter}</p>
                    </div>
                  </div>
                </CarouselItem>
              ))}
            </CarouselContent>
            <div className="flex justify-center gap-2 mt-4">
              <CarouselPrevious className="relative static translate-y-0 left-0" />
              <CarouselNext className="relative static translate-y-0 right-0" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>
  );
};

export default EventsSection;
